<script setup lang="ts">
import VSkeletonBar from './v-skeleton-bar.vue'

export interface DescriptionItem {
  label: string
  value?: string
  key?: string
}

defineProps<{
  items: DescriptionItem[]
  loading?: boolean
  title?: string
}>()

const placeholderCount = 4
</script>

<template>
  <div class="w-full rounded-lg border bg-white p-3">
    <div v-if="title" class="font-medium leading-7 text-gray-700">
      {{ title }}
    </div>

    <dl class="divide-y divide-[var(--divider-color,#EEEFF0)]" :class="title ? 'mt-3' : ''">
      <div
        v-for="(_item, index) in items.length || (loading ? placeholderCount : 0)"
        :key="items[index]?.key || index"
        class="flex items-center justify-between gap-6 py-1"
      >
        <dt class="whitespace-pre-line text-gray-600">
          <template v-if="loading">
            <VSkeletonBar />
          </template>
          <template v-else>
            {{ items[index]?.label }}
          </template>
        </dt>

        <dd class="whitespace-pre-line text-gray-900">
          <template v-if="loading">
            <VSkeletonBar />
          </template>
          <template v-else>
            <slot
              v-if="items[index]?.key && $slots[items[index]?.key]"
              v-bind="items[index]"
              :name="items[index]?.key"
              :item="items[index]"
            />
            <template v-else>
              {{ items[index]?.value }}
            </template>
          </template>
        </dd>
      </div>
    </dl>
  </div>
</template>
